import { useRef } from "react";
import { useLocation } from "react-router";

import { analytics } from "~/analytics";
import { UTM_PARAMS } from "~/lib/constants";
import {
  isValidShareId,
  SHARE_ACTION_SOURCE,
  SHARE_ID_PARAM,
  SHARE_SOURCE_PARAM,
  URL_COPY_SOURCE,
} from "~/lib/share-attribution";
import { ensureUserData } from "~/stores/reactQuery/useUserQuery";

function isTrackedReferralParam([key, value]: [string, string]) {
  if (!UTM_PARAMS.includes(key)) return false;
  if (key === SHARE_ID_PARAM) return isValidShareId(value);
  if (key === SHARE_SOURCE_PARAM) return value === SHARE_ACTION_SOURCE || value === URL_COPY_SOURCE;
  return true;
}

export function useAnalyticsTrackReferral() {
  const location = useLocation();
  const sent = useRef<boolean>(false);

  async function getURLSearchParams() {
    const user = await ensureUserData();
    const unauthenticatedUser = !user;

    const eventName = unauthenticatedUser ? "Unauthenticated Referral Visit" : "Authenticated Referral Visit";

    const searchParams = new URLSearchParams(location.search);
    const utmReferralParams = Object.fromEntries([...searchParams.entries()].filter(isTrackedReferralParam));
    const isOwnShareUrl = Boolean(user?.externalId && utmReferralParams.ref_user === user.externalId);

    if (!sent.current && !isOwnShareUrl && Object.keys(utmReferralParams).length > 0) {
      analytics.track({
        event: eventName,
        properties: {
          ...utmReferralParams,
          path: location.pathname,
          url: window.location.href,
          ...(user ? { userId: user.id } : null),
          $set: {
            referred_user: true,
          },
        },
      });
      sent.current = true;
    }
  }

  return { getURLSearchParams };
}
